/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_TitleInputs */

const en_mk_abt_title = /** @type {(inputs: Mk_Abt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for offices that have no IT department`)
};

const id_mk_abt_title = /** @type {(inputs: Mk_Abt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibuat untuk kantor yang tidak punya tim IT`)
};

/**
* | output |
* | --- |
* | "Built for offices that have no IT department" |
*
* @param {Mk_Abt_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_title = /** @type {((inputs?: Mk_Abt_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_title(inputs)
	return en_mk_abt_title(inputs)
});